<template>
  <div>
    <!-- 文件夹列表 -->
    <el-card class="img-card" style="margin-top:5px; min-height:20vh" shadow="never" v-loading="loading">
      <!-- 头部 -->
      <div slot="header" class="card-header" v-if="isShowHeader">

        <el-row :gutter="10" type="flex" v-if="source == 'allMaterial' && !isOpenFolder">
          <el-col :span="21" class="tag-box">
            <!-- <el-tag size="mini" v-for="(tag,index) in checkedTags" :key="index" closable :type="tag.name" @close="handleClose(tag)">{{tag.name}}</el-tag> -->

            <el-tag size="mini" v-for="(tag,index) in checkedTags" :key="index" closable :type="tag.name" @close="handleClose(tag,index)">
              <span class="title">{{tag.labelName}}：</span>
              <span v-for="(item,itemIndex) in tag.list" :key="itemIndex">{{item.name}}<i v-if="itemIndex < tag.list.length-1">、</i></span>
            </el-tag>

            <el-button size="mini" type="text" style="color:#F56C6C" v-if="checkedTags.length > 0" @click="handleEmpty">清空筛选</el-button>

          </el-col>
          <el-col :span="3" class="butn-box">
            <!-- <el-radio-group size="mini" v-model="imageType">
                            <el-radio-button label="1"><i class="el-icon-s-grid"></i></el-radio-button>
                            <el-radio-button label="2"><i class="el-icon-menu"></i></el-radio-button>
                        </el-radio-group> -->

            <el-radio-group size="mini" v-model="orderByType" @change="handleFilter">
              <el-radio label="1">默认排序</el-radio>
              <el-radio label="2">下载量优先</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>

        <!-- 面包屑导航 -->
        <el-breadcrumb separator="/" v-if="isOpenFolder">
          <el-breadcrumb-item class="cursor" @click.native="handleGoBack('全部')">全部文件</el-breadcrumb-item>
          <template v-if="breadcrumbList.length > 0">
            <el-breadcrumb-item v-for="(item,index) in breadcrumbList" :key="index">
              <span class="cursor" v-if="index < breadcrumbList.length-1" @click="handleGoBack(item.id)">{{item.fileName}}</span>
              <span style="cursor:not-allowed" v-else>{{item.fileName}}</span>
            </el-breadcrumb-item>
          </template>
        </el-breadcrumb>

      </div>

      <div class="content-box" @contextmenu="handleShowMenu">
        <!-- 全选按钮 -->
        <div class="opera-box" v-if="source == 'team' && sourceList.length > 0">
          <el-checkbox class="checkbox-all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div class="butn-box">
            <el-button v-if="accessPoint['team:download']" class="allDownload" size="mini" type="primary" @click="handleDownloadAll" :disabled="isDisabled">下载<i class="el-icon-download el-icon--right"></i></el-button>
            <el-button v-if="accessPoint['team:delete']" class="allDownload" size="mini" type="danger" @click="handleDeleteAll" :disabled="isDisabled">删除<i class="el-icon-delete el-icon--right"></i></el-button>
          </div>
        </div>

        <!-- 列表 -->
        <el-row :gutter="20" class="img-box">
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="card" v-for="(item,index) in sourceList" :key="index">
            <el-card class="img-item" :class="item.checked ? 'checked-active' : ''" :body-style="{ padding: '0px' }" shadow="hover">
              <div class="img" @mouseleave="item.isMark = false" v-if="source != 'recycle'">
                <!-- 推送 -->
                <div class="set-box" v-if="source == 'allMaterial'">
                  <!--   是否已同步外网，2为已同步，其余未  v-if="item.inOutStatus!=2 && synchro==2"-->
                  <!-- <div class="set-item" v-if="item.outFile==false && synchro==2">
                    <el-tooltip class="icon-butn" effect="dark" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                      <span slot="content">同步外网</span>
                      <svg-icon icon-class="synchro" @click="handleSynchro(item)" />
                    </el-tooltip>
                  </div> -->

                  <!-- <div class="set-item" v-show="item.inOutStatus==1 && synchro==2">
                    <el-tooltip class="icon-butn" effect="dark" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                      <span slot="content">同步外网中,强制重新执行</span>
                      <i class="el-icon-loading" @click="handleSynchroAgain(item)" style="font-size:16px"></i>
                    </el-tooltip>
                  </div> -->

                  <!-- <div class="set-item" @click="handlePushFolder(item)" v-if="accessPoint['ads:push']">
                    <el-tooltip class="icon-butn" effect="dark" content="推送" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                      <svg-icon icon-class="push_shape" />
                    </el-tooltip>
                  </div> -->
                </div>

                <!-- 文件夹 -->
                <div class="imgStyle img-style" v-if="item.fileType == 3">
                  <template v-if="source == 'team' && (accessPoint['team:update'] || accessPoint['team:delete'])">
                    <i class="el-icon-s-tools mark" @click="item.isMark = !item.isMark"></i>
                    <ul class="el-dropdown-menu el-popper el-dropdown-menu--medium popper" v-if="item.isMark">
                      <li class="el-dropdown-menu__item" v-if="accessPoint['team:update']" @click="handleOpenEdit(item)"><i class="el-icon-edit-outline" style="color:#409EFF"></i>重命名</li>
                      <li class="el-dropdown-menu__item" v-if="accessPoint['team:delete']" @click="handleDeleteFolder(item)"><i class="el-icon-delete" style="color:#F56C6C"></i>删除</li>
                      <div x-arrow="" class="popper__arrow" style="left: 85px;top: -6px;"></div>
                    </ul>
                  </template>
                  <!-- <i class="el-icon-folder-opened image__inner" @click="handleFolder(item)"></i> -->
                  <svg-icon class="image__inner" icon-class="floder-blue" @click="handleFolder(item)" />
                </div>

                <!-- 视频或图片 -->
                <div class="img-style" v-else>
                  <template v-if="source == 'team' && (accessPoint['team:update'] || accessPoint['team:delete'] || accessPoint['team:download'])">
                    <div class="checkbox">
                      <el-checkbox v-model="item.checked" @change="handleCheckedItemChange($event,item)"></el-checkbox>
                    </div>
                    <i class="el-icon-s-tools mark" @click="item.isMark = !item.isMark"></i>
                    <ul class="el-dropdown-menu el-popper el-dropdown-menu--medium popper" v-if="item.isMark">
                      <li class="el-dropdown-menu__item" v-if="accessPoint['team:update']" @click="handleOpenEdit(item)"><i class="el-icon-edit-outline" style="color:#409EFF"></i>重命名</li>
                      <li class="el-dropdown-menu__item" v-if="accessPoint['team:delete']" @click="handleDeleteFolder(item)"><i class="el-icon-delete" style="color:#F56C6C"></i>删除</li>
                      <li class="el-dropdown-menu__item" v-if="accessPoint['team:download']" @click="handleDownload(item)"><i class="el-icon-download"></i>下载</li>
                      <div x-arrow="" class="popper__arrow" style="left: 85px;top: -6px;"></div>
                    </ul>
                  </template>

                  <div class="video-bg" v-if="item.fileType == 2" @click="handleImageViewer(item)"></div>
                  <el-image class="imgStyle" :src="item.thumbnailImageUrl" lazy @click="handleImageViewer(item)">
                    <div slot="error" class="el-image__error image-slot">
                      <i class="el-icon-picture-outline"></i>
                      <span style="line-height:30px">缺少资源</span>
                    </div>
                  </el-image>
                </div>
              </div>

              <div class="img" v-else @click="item.isMark = !item.isMark">
                <!-- 文件夹 -->
                <div class="imgStyle" v-if="item.fileType == 3">
                  <!-- <i class="el-icon-folder-opened image__inner"></i> -->
                  <svg-icon class="image__inner" icon-class="floder-blue" />
                </div>

                <!-- 视频或图片 -->
                <template v-else>
                  <div class="video-bg" v-if="item.fileType == 2"></div>
                  <el-image class="imgStyle" :src="item.thumbnailImageUrl" lazy>
                    <div slot="error" class="el-image__error image-slot">
                      <i class="el-icon-picture-outline"></i>
                      <span style="line-height:30px">缺少资源</span>
                    </div>
                  </el-image>
                </template>

                <!-- 回收站点击提示 -->
                <div class="recycleMark" v-if="item.isMark">
                  <ul class="el-dropdown-menu el-popper el-dropdown-menu--medium popper">
                    <li class="el-dropdown-menu__item" @click.stop="handleRecover(item)" v-if="accessPoint['trash:recover']"><i class="el-icon-thumb" style="color:#409EFF"></i>恢复文件</li>
                    <li class="el-dropdown-menu__item" @click.stop="handleRemove(item)" v-if="accessPoint['trash:delete']"><i class="el-icon-delete" style="color:#F56C6C"></i>彻底删除</li>
                    <div x-arrow="" class="popper__arrow" style="left: 85px;top: -6px;"></div>
                  </ul>
                </div>
              </div>

              <div class="text-box">
                <div class="item title" v-if="(source == 'allMaterial' || source == 'recycle') && item.fileType == 3">
                  <!-- <label >文件名：</label> -->
                  <span>{{item.fileName}}</span>
                </div>
                <div class="item title" v-if="source == 'team'">
                  <!-- <label >文件名：</label> -->
                  <span v-if="!item.edit">{{item.fileName}}</span>
                  <template v-else>
                    <el-input v-if="item.fileType == 3" size="mini" v-model="item.fileName" style="width:100px;"></el-input>

                    <el-input v-else size="mini" v-model="item.prefixName" style="width:100px;"></el-input>

                    <i class="el-icon-check" style="cursor: pointer; color:#67C23A;font-size:18px;margin-right:5px" @click="handleSaveName(item)"></i>
                    <i class="el-icon-close" style="cursor: pointer; color:#F56C6C;font-size:18px" @click="handleCancel(item)"></i>
                  </template>
                </div>

                <div class="item title" v-if="item.fileType != 3 && source != 'team'">
                  <!-- <label>尺寸：</label> -->
                  <span>{{item.size}}</span>
                </div>
                <div class="item">
                  <!-- <label>{{item.designerName ? '设计师' : '创建人'}}：</label> -->
                  <span :title="item.designerName? item.designerName: item.createUserName">{{item.designerName? item.designerName: item.createUserName}}</span>
                </div>
                <div class="item">
                  <!-- <label>{{item.fileType == 3 ? '创建时间' : '上传时间'}}：</label> -->
                  <span :title="item.createTimeStr">{{item.createTimeStr}}</span>
                </div>

              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 分页 -->
        <pagination v-show="total>0" :total="total" layout="total, prev, pager, next, jumper" :page.sync="listQuery.pageNo" :limit.sync="pageSize" :autoScroll="false" @pagination="refreshList" style="margin-top:0" />

        <!-- 暂无数据提示 -->
        <div v-if="sourceList.length == 0" style="width:100%;line-height:20vh;color:#909399;text-align:center">暂无数据！</div>

        <!-- 右键菜单 -->
        <vue-context-menu v-if="source == 'team'" :contextMenuData="contextMenuData" @create="handleCreateFolder">
        </vue-context-menu>
      </div>
    </el-card>

    <!-- 图片预览 -->
    <image-viewer v-if="showViewer" :source="source" :show-viewer="showViewer" :on-close="closeViewer" :url-list="[bugUrl]" :list-data="detailsData" @download="handleDownload" @share="handleShare"
      @delete="handleDeleteFolder" @push="handlePushFolder"></image-viewer>

    <!-- 链接分享 -->
    <el-dialog class="dialog" title="链接分享" :visible.sync="dialogVisible" width="35%">
      <div class="box">
        <el-input size="small" v-model="shareUrl" placeholder="请输入内容" style="width:60%"></el-input>
        <el-button size="small" v-clipboard:copy="shareUrl" v-clipboard:success="clipboardSuccess" type="primary" icon="el-icon-document">复制链接</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 推送 -->
    <push-list ref="push"></push-list>
  </div>
</template>

<script>
import Vue from 'vue'
import ImageViewer from './ImageViewer'
import clipboard from '@/directive/clipboard/index.js'
import Pagination from '@/components/Pagination'
import { apiUrl } from '@File~/api/env'
import store from '@Sys~/store'
import { fileDetail_ajax, modifyFolder_ajax, deleteFileFolder_ajax, deleteRecycleFileFolder_ajax, recoveryRecycleFileFolder_ajax, modifyFileName_ajax, syncFileInToOut_ajax } from '@File~/api/file'
import VueContextMenu from 'vue-contextmenu'
import PushList from './pushList.vue'

Vue.use(VueContextMenu)
export default {
  props: {
    // 数据源列表
    sourceList: {
      type: Array,
      default: () => []
    },

    // 是否展示header
    isShowHeader: {
      type: Boolean,
      default: true
    },
    // 面包屑列表
    breadcrumbList: {
      type: Array,
      default: () => []
    },

    // 打开文件夹
    isOpenFolder: {
      type: Boolean,
      default: false
    },

    // 来源
    source: {
      type: String,
      default: ''
    },

    // tabs
    checkedTags: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 12
    }
  },

  directives: { clipboard },
  components: { ImageViewer, Pagination, PushList },
  data() {
    return {
      synchro: 1,
      loading: false,
      total: 0,
      listQuery: {
        pageNo: 1
      },

      // imageType:'1',
      orderByType: '1',

      showViewer: false, // 显示图片预览弹窗
      bugUrl: '', // 详情图片地址
      detailsData: {}, // 详情
      dialogVisible: false, // 复制弹窗

      shareUrl: '', // 分享地址

      // 右键菜单数据
      contextMenuData: {
        menuName: 'menuBox',
        // 菜单显示位置
        axis: {
          x: null,
          y: null
        },

        // 菜单选项
        menulists: [
          {
            fnHandler: 'create', //绑定事件
            icoName: 'el-icon-folder', //icon图标
            btnName: '新建文件夹' //菜单名称
          }
        ]
      },

      accessPoint: this.$store.getters.accessPoint, //权限点

      // 全选
      checkAll: false,
      checkedItem: [],
      isIndeterminate: false,
      isDisabled: true,

      timer: null

    }
  },

  filters: {
    textFile(value) {
      if (value.length > 30) {
        return value.replace(/<[^<>]+>/g, "").substring(0, 30) + "...";
      } else {
        return value
      }
    },
  },

  created() {

  },

  mounted() {
    setTimeout(() => {
      this.synchro = this.$store.getters.synchro
    }, 300);

  },

  methods: {
    // init
    init() {

      this.checkAll = false
      this.checkedItem = []
      this.isIndeterminate = false
      this.isDisabled = true
    },

    // 重新获取数据
    refreshList() {
      if (this.breadcrumbList.length > 0) {
        this.$emit('refreshList', this.breadcrumbList[this.breadcrumbList.length - 1].id)
      } else {
        this.$emit('refreshList')
      }
    },

    // 查询数据
    handleFilter() {
      this.$emit('handleFilter')
    },

    // 预览大图
    handleImageViewer(item) {
      // if (item.outFile == false && this.synchro == 2) {
      //   this.$message.warning("请先将文件同步至外网")
      //   return false
      // }

      // 获取详情接口
      fileDetail_ajax(item.id).then(response => {
        if (response.code == 1) {
          const data = response.data
          if (data.fileType == 1 && data.loadFileBinaryUrl) { // 图片 显示大图
            this.bugUrl = data.loadFileBinaryUrl
          }

          if (data.fileType == 2 || data.fileType == 0) {// 视频、其它
            this.bugUrl = data.thumbnailImageUrl
          }

          if (data.fileType !== 3) {// 除文件夹外都可以打开
            this.detailsData = data
            this.showViewer = true;
          }
        }
      })
    },

    // 关闭图片预览
    closeViewer() {
      // console.log('关闭预览===')
      this.showViewer = false
      this.bugUrl = ''
      this.listData = {}
    },

    // 下载
    handleDownload(item) {
      // if (item.outFile == false && this.synchro == 2) {
      //   this.$message.warning("请先将文件同步至外网")
      //   return false
      // }
      // console.log(item)
      // 创建form 表单
      var form = document.createElement('form')
      document.body.appendChild(form)
      form.setAttribute('style', 'display:none');
      form.setAttribute('method', 'post');
      // form.setAttribute('action',apiUrl.fileUrl+'/api/file/downloadFile');//下载文件的请求路径

      form.setAttribute('action', this.$store.getters.downloadUrl);//下载文件的请求路径

      // 创建表单里 input 元素
      var tempInput = document.createElement("input");
      tempInput.type = "hidden";
      tempInput.name = 'fileId';
      tempInput.value = item.id;
      form.appendChild(tempInput);

      var tempInput2 = document.createElement("input");
      tempInput2.type = "hidden";
      tempInput2.name = 'userId';
      tempInput2.value = store.getters.userId;
      form.appendChild(tempInput2);

      // console.log('表单===',form)

      form.submit()
      document.body.removeChild(form)
    },

    // 推送文件
    handlePushFolder(item) {
      // console.log('推送文件====')
      this.$refs['push'].init(item)
    },

    // 同步文件
    handleSynchro(item) {
      // console.log('同步文件====')
      this.$confirm('确定要将素材同步到外网吗？', '同步外网', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.synchro_ajax(item)

      }).catch(() => {

      });
    },

    synchro_ajax(item) {
      item.inOutStatus = 1
      const data = {
        "fileId": item.id,
        "userId": this.$store.getters.userId,
        "repeat": 0,//是否强制重新执行 默认：0:不强制重新执行 1:强制重新执行
      }
      // 同步接口
      syncFileInToOut_ajax(data).then(response => {
        if (response.code == 1) {
          if (response.data.inOutStatus != 2) {
            setTimeout(() => {
              this.synchro_ajax(item)
            }, 500);
          } else {
            item.inOutStatus = 2
            this.$message.success(item.fileName + ' 同步完成');
            item.thumbnailImageUrl = response.data.thumbnailImageUrl + "&v=1.1"
          }

        }
      })
    },

    handleSynchroAgain(item) {
      // console.log('同步文件====')
      this.$confirm('强制重新将素材同步到外网吗？', '同步外网', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.inOutStatus = 1
        const data = {
          "fileId": item.id,
          "userId": this.$store.getters.userId,
          "repeat": 1,//是否强制重新执行 默认：0:不强制重新执行 1:强制重新执行
        }
        // 同步接口
        syncFileInToOut_ajax(data).then(response => {
          if (response.code == 1) {
            if (response.data.inOutStatus != 2) {
              setTimeout(() => {
                this.synchro_ajax(item)
              }, 500);
            } else {
              item.inOutStatus = 2
              this.$message.success(item.fileName + ' 同步完成');
              item.thumbnailImageUrl = response.data.thumbnailImageUrl + "&v=1.1"
            }
          }
        })

      }).catch(() => {

      });
    },

    // 分享
    handleShare(item) {
      // console.log(item)
      this.dialogVisible = true
      this.shareUrl = item.loadFileBinaryUrl
    },

    // 拷贝
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success',
        duration: 1500
      })
    },

    // 打开文件夹
    handleFolder(item) {
      this.$emit('openFolder', item)
    },

    // 返回上一级
    handleGoBack(val) {
      console.log(val)
      this.$emit('goBack', val)
    },

    // 删除tabs
    handleClose(tag, index) {
      this.$emit('closeTag', tag, index)
    },

    // 清空
    handleEmpty() {
      this.$emit('emptyTags')
    },

    // 操作重命名
    handleOpenEdit(item) {
      // console.log(item.edit);
      item.isMark = false;
      item.edit = true
    },

    // 删除文件夹 文件
    handleDeleteFolder(item) {
      this.$confirm('删除后，所有共享者都无法访问此文件，是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          "fileItems": [
            {
              id: item.id,
              type: item.fileType
            }
          ]
        }
        deleteFileFolder_ajax(data).then(response => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          item.isMark = false;

          if (this.breadcrumbList.length > 0) {
            this.$emit('handleFilter', this.breadcrumbList[this.breadcrumbList.length - 1].id)
          } else {
            this.$emit('handleFilter')
          }


          if (this.showViewer) {
            this.showViewer = false
          }
        })

      }).catch(() => {

      });
    },

    // 保存文件名
    handleSaveName(item) {
      if (item.fileType == 3) {
        modifyFolder_ajax(item.id, item.fileName).then(response => {
          if (response.code == 1) {
            item.edit = false
            item.fileName = response.data.folderName
            // this.$emit('handleFilter')
          }
        })
      } else {
        const folderPid = this.breadcrumbList[this.breadcrumbList.length - 1].id
        const fileName = item.prefixName + item.suffixName
        modifyFileName_ajax(item.id, fileName, folderPid).then(response => {
          if (response.code == 1) {
            item.edit = false
            item.fileName = response.data.fileName
          }
        })
      }

    },

    // 取消文件名
    handleCancel(item) {
      item.edit = false
      item.fileName = JSON.parse(JSON.stringify(item.originalFolderName))
    },

    // 恢复文件
    handleRecover(item) {
      const data = {
        "fileItems": [
          {
            id: item.id,
            type: item.fileType
          }
        ]
      }

      recoveryRecycleFileFolder_ajax(data).then(response => {
        if (response.code == 1) {
          this.$message({
            type: 'success',
            message: '恢复文件成功!'
          });
          item.isMark = false;
          this.$emit('handleFilter')
        }
      })
    },

    // 彻底删除 删除回收站里的文件 文件夹
    handleRemove(item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          "fileItems": [
            {
              id: item.id,
              type: item.fileType
            }
          ]
        }
        deleteRecycleFileFolder_ajax(data).then(response => {
          if (response.code == 1) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });

            item.isMark = false;
            this.$emit('handleFilter')
          }
        })

      }).catch(() => {

      });
    },

    // 右键菜单
    handleShowMenu() {
      // console.log('右键====')
      if (this.source == 'team') {
        event.preventDefault()
        var x = event.clientX
        var y = event.clientY
        // Get the current location
        this.contextMenuData.axis = {
          x, y
        }
      }
    },

    // 新建文件夹
    handleCreateFolder() {
      this.$emit('createFolder')
    },

    // 全选
    handleCheckAllChange(val) {
      if (val) {
        this.checkAll = true
        this.isIndeterminate = false
        this.checkedItem = this.filterList(val)
        if (this.checkedItem.length > 0) {
          this.isDisabled = false
        } else {
          this.isDisabled = true
        }
      } else {
        this.checkAll = false
        this.checkedItem = []
        this.isIndeterminate = false
        this.filterList(val)
        this.isDisabled = true
      }
    },

    // 选项
    handleCheckedItemChange(val, item) {
      item.checked = val
      if (val) {
        this.checkedItem.push(item)
      } else {
        console.log(this.checkedItem.indexOf(item))
        this.checkedItem.splice(this.checkedItem.indexOf(item), 1)
      }

      const list = this.filterList()
      if (this.checkedItem.length > 0 && this.checkedItem.length < list.length) {
        this.isIndeterminate = true
        this.checkAll = false
        this.isDisabled = false
      } else if (this.checkedItem.length == list.length) {
        this.isIndeterminate = false
        this.checkAll = true
        this.isDisabled = false
      } else if (this.checkedItem.length == 0) {
        this.isIndeterminate = false
        this.checkAll = false
        this.isDisabled = true
      }
    },

    // 除了文件夹外的所有文件
    filterList(val) {
      const list = []
      this.sourceList.forEach(item => {
        if (item.fileType != 3) {
          list.push(item)
          if (val == true) {
            item.checked = true
          } else if (val == false) {
            item.checked = false
          }
        }
      })

      return list
    },

    // 批量下载
    handleDownloadAll() {
      // if (this.$store.getters.synchro == 2) {
      //   var num = false
      //   for (var i = 0; i < this.checkedItem.length; i++) {
      //     if (this.checkedItem[i].outFile == false) {
      //       num = true
      //       break
      //     }
      //   }
      //   if (num) {
      //     this.$message.warning("请先将文件同步至外网")
      //     return false
      //   }
      // }

      if (this.checkedItem.length > 0) {
        let count = this.checkedItem.length

        this.timer = setInterval(() => {
          if (count > 0 && count <= this.checkedItem.length) {
            count--;
            this.handleDownload(this.checkedItem[count])
          } else {
            clearInterval(this.timer);  // 清除定时器
            this.timer = null;
          }
        }, 5000)
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择要下载的文件!'
        });
      }
    },

    // 批量删除
    handleDeleteAll() {
      if (this.checkedItem.length > 0) {
        let list = []

        this.checkedItem.forEach(item => {
          list.push({
            id: item.id,
            type: item.fileType
          })
        })
        const data = {
          "fileItems": list
        }
        deleteFileFolder_ajax(data).then(response => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          if (this.breadcrumbList.length > 0) {
            this.$emit('handleFilter', this.breadcrumbList[this.breadcrumbList.length - 1].id)
          } else {
            this.$emit('handleFilter')
          }

        })

      } else {
        this.$message({
          type: 'warning',
          message: '请先选择要删除的文件!'
        });
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.img-card {
  ::v-deep .el-card__header {
    padding: 5px 20px;
  }
  .card-header {
    min-height: 24px;
    height: auto;
    .tag-box {
      display: flex;
      flex-flow: row wrap;
    }
    .butn-box {
      min-width: 210px;
      text-align: right;
    }
  }
  .cursor {
    cursor: pointer;
  }
  .el-tag {
    height: auto;
    min-height: 24px;
    margin-right: 10px;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    margin: 3px 10px 3px 0;
  }
  ::v-deep .el-radio-button {
    margin-left: 6px;
  }
  ::v-deep .el-radio-button__inner {
    border: 0;
    padding: 2px 0;
    font-size: 24px;
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-radius: 0;
    box-shadow: none;
    color: #1890ff;
    background: transparent;
  }
  ::v-deep .el-card__body {
    padding: 15px 20px 5px;
  }

  ::v-deep .el-radio {
    margin: 5px 10px 5px 0;
  }
}
.img-box {
  // display: flex;
  // flex-flow: row wrap;
  .card {
    flex: auto;
    // min-width: 300px;
    // width: 20%; // calc(100% / 5); //16.54vw;
    // max-width:380px;
    height: auto;
    margin-bottom: 20px;
    .img {
      width: 100%;
      height: 140px;
      overflow: hidden;
      padding: 2px 8px;
      background: #f5f5f5;
      position: relative;
    }
    .video-bg {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 7;
      margin: -25px;
      background-image: url("../../../assets/video.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      cursor: pointer;
    }
    .imgStyle,
    .img-style {
      width: 100%;
      height: 100%;
      display: block;
      text-align: center;
      line-height: 140px;
      position: relative;
      cursor: pointer;
      ::v-deep .el-image__inner {
        // display: inline-block;
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        // cursor: pointer;
        // vertical-align:middle;
      }
      ::v-deep .el-image__inner {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }

      .image__inner {
        font-size: 125px;
        // color: #ef9f27;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }

      ::v-deep .image-slot {
        flex-flow: column nowrap;
      }

      .checkbox {
        position: absolute;
        top: 4px;
        left: 0;
        width: 16px;
        height: 16px;
        z-index: 9;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        ::v-deep .el-checkbox {
          display: flex;
          flex-flow: column nowrap;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          width: 100%;
          height: 100%;
          .el-checkbox__inner {
            // width: 18px !important;
            // height: 18px !important;
            //border: 1px solid #909090;
          }
          .el-checkbox__inner::after {
            // width: 4px;
            // height: 10px;
            // left: 5px;
            // border-width: 2px;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            border: 1px solid #1890ff;
          }
        }
      }

      .mark {
        // display: block;
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        opacity: 0;
        font-size: 24px;
        z-index: 9;
      }
      .popper {
        width: 100px;
        text-align: left;
        position: absolute;
        top: 24px;
        left: 58%;
        ::v-deep .popper__arrow:after {
          top: -6px;
          margin-left: -6px;
          border-top-width: 0;
          border-bottom-color: #fff;
        }
      }
    }

    .set-box {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
      align-items: flex-start;
      width: 100%;
      height: 42px;
      padding: 6px;
      overflow: hidden;
      position: absolute;
      top: 0px;
      right: 0px;
      opacity: 0;
      z-index: 1;
      transition: 0.3s;
      .set-item {
        width: 30px;
        height: 30px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        margin-left: 4px;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .icon-butn {
          width: 16px;
          height: 16px;
          color: #666;
        }
      }
    }
    .recycleMark {
      position: absolute;
      top: 5%;
      right: 5%;
      width: 112px;
      height: 76px;
    }
    ::v-deep .el-image-viewer__btn {
      color: #fff;
    }
    .text-box {
      padding: 4px 12px 8px;
      // display: flex;
      // flex-flow: row wrap;
      height: 80px;
      // .item{
      //     margin: 2px 0px;
      //     font-size: 12px;
      //     line-height: 1.3;
      //     width: 100%;
      //     white-space: nowrap;
      //     text-overflow: ellipsis;
      //     overflow: hidden;
      //     word-break: break-all;
      // }
      .item {
        line-height: 1.4;
        width: 100%;
        margin: 4px 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .title {
        margin: 0;
        line-height: 28px;
        font-size: 14px;
        color: #333333;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
      }
      // label{
      //     font-weight: normal;
      //     color: #aeaeae;
      //     line-height: 1.2;
      // }
      // span{
      //     color: #424242;
      //     line-height: 1.2;
      // }
      // ::v-deep .el-input__inner{
      //     height: 24px;
      //     line-height: 24px;
      // }
    }

    &:hover {
      .mark {
        opacity: 1;
      }
    }
  }

  .img-item {
    border: 1px solid #eeeeee;
    font-size: 12px;
    color: #999;
  }

  .img-item:hover {
    .set-box {
      opacity: 1;
    }
  }
}
.content-box {
  .opera-box {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    margin-top: -5px;
    .checkbox-all {
    }
  }
  .vue-contextmenuName-menuBox {
    background: rgba(0, 0, 0, 0.59);
    color: #fff;
    padding: 10px 10px;
    border-radius: 5px;
    ::v-deep .context-menu-list {
      background: transparent !important;
    }
    ::v-deep .btn-wrapper-simple {
      display: flex;
      align-items: center;
    }
    ::v-deep .btn-wrapper-simple:hover {
      color: #1890ff;
    }
  }
}

.checked-active {
  border: 1px solid #1890ff;
  background-color: #edf9ff;
}
</style>

<style lang="scss">
.tooltip {
  font-size: 12px;
  padding: 3px 6px;
  background: #000000;
  border-radius: 2px;
  opacity: 0.5;
}
</style>
